export const formData = (t) => ({
  initialQuestion: t('initialQuestion'),
  options: [
    { value: 'lost-animal', label: t('lostAnimal') },
    { value: 'found-animal', label: t('foundAnimal') },
    { value: 'psa', label: t('psa') },
    { value: 'pet-service', label: t('petService', 'Pet Service') }
  ],
  fields: {
    'lost-animal': [
      { 
        label: t('animal_type'), 
        name: 'animalType', 
        type: 'select', 
        options: [
          { name: 'dog', value: t('dog'), label: t('dog') },
          { name: 'cat', value: t('cat'), label: t('cat') },
          { name: 'bird', value: t('bird'), label: t('bird') },
          { name: 'reptile', value: t('reptile'), label: t('reptile') },
          { name: 'small_mammal', value: t('small_mammal'), label: t('small_mammal') },
          { name: 'other', value: t('other'), label: t('other') }
        ], 
        placeholder: t('select_animal_type') 
      },
      { label: t('animalName'), name: 'animalName', type: 'text', placeholder: t('animalNamePlaceholder') },
      { 
        label: t('colorMarkings'), 
        name: 'colorMarkings', 
        type: 'checkbox', 
        options: [
          { name: 'dark_brown', value: t('dark_brown'), label: t('dark_brown') },
          { name: 'light_brown', value: t('light_brown'), label: t('light_brown') },
          { name: 'gray', value: t('gray'), label: t('gray') },
          { name: 'black', value: t('black'), label: t('black') },
          { name: 'white', value: t('white'), label: t('white') },
          { name: 'spotted', value: t('spotted'), label: t('spotted') },
          { name: 'orange', value: t('orange'), label: t('orange') },
          { name: 'blonde', value: t('blonde'), label: t('blonde') },
          { name: 'blend', value: t('blend'), label: t('blend') },
          { name: 'stripes', value: t('stripes'), label: t('stripes') },
          { name: 'other', value: t('other'), label: t('other') }
        ], 
        placeholder: t('colorMarkingsPlaceholder') 
      },
      { label: t('breed'), name: 'breed', type: 'text', placeholder: t('breedPlaceholder') },
      {
        label: t('estimatedWeight'),
        name: 'estimatedWeight',
        type: 'select',
        options: [
          { label: t('weight_xsmall'), value: t('weight_xsmall') },
          { label: t('weight_small'), value: t('weight_small') },
          { label: t('weight_medium'), value: t('weight_medium') },
          { label: t('weight_large'), value: t('weight_large') },
          { label: t('weight_xlarge'), value: t('weight_xlarge') }
        ],
        placeholder: t('estimatedWeightPlaceholder')
      },
      { label: t('dateLost'), name: 'dateLost', type: 'date', placeholder: t('dateLostPlaceholder') },
      { label: t('lastSeen'), name: 'lastSeen', type: 'text', placeholder: t('lastSeenPlaceholder') },
      { 
        label: t('sex'), 
        name: 'sex', 
        type: 'select', 
        options: [
          { label: t('male'), value: t('male') },
          { label: t('female'), value: t('female') },
          { label: t('unknown'), value: t('unknown') }
        ], 
        placeholder: t('sexPlaceholder') 
      },
      { label: t('your_name', 'Your Name'), name: 'contactName', type: 'text', placeholder: t('contactNamePlaceholder') },
      { 
        label: t('approachable'), 
        name: 'approachable', 
        type: 'radio', 
        options: [
          { label: t('yes'), value: 'yes' },
          { label: t('no'), value: 'no' }
        ], 
        placeholder: t('approachablePlaceholder') 
      },
      { label: t('uploadImage'), name: 'animalImage', type: 'file', placeholder: t('uploadImagePlaceholder') }
    ],
    'found-animal': [
      { 
        label: t('animal_type'), 
        name: 'animalType', 
        type: 'select', 
        options: [
          { name: 'dog', value: t('dog'), label: t('dog') },
          { name: 'cat', value: t('cat'), label: t('cat') },
          { name: 'bird', value: t('bird'), label: t('bird') },
          { name: 'reptile', value: t('reptile'), label: t('reptile') },
          { name: 'small_mammal', value: t('small_mammal'), label: t('small_mammal') },
          { name: 'other', value: t('other'), label: t('other') }
        ], 
        placeholder: t('select_animal_type') 
      },
      { label: t('animalName'), name: 'animalName', type: 'text', placeholder: t('animalNamePlaceholder') },
      { 
        label: t('colorMarkings'), 
        name: 'colorMarkings', 
        type: 'checkbox', 
        options: [
          { name: 'dark_brown', value: t('dark_brown'), label: t('dark_brown') },
          { name: 'light_brown', value: t('light_brown'), label: t('light_brown') },
          { name: 'gray', value: t('gray'), label: t('gray') },
          { name: 'black', value: t('black'), label: t('black') },
          { name: 'white', value: t('white'), label: t('white') },
          { name: 'spotted', value: t('spotted'), label: t('spotted') },
          { name: 'orange', value: t('orange'), label: t('orange') },
          { name: 'blonde', value: t('blonde'), label: t('blonde') },
          { name: 'blend', value: t('blend'), label: t('blend') },
          { name: 'stripes', value: t('stripes'), label: t('stripes') },
          { name: 'other', value: t('other'), label: t('other') }
        ], 
        placeholder: t('colorMarkingsPlaceholder') 
      },
      { label: t('breed'), name: 'breed', type: 'text', placeholder: t('breedPlaceholder') },
      {
        label: t('estimatedWeight'),
        name: 'estimatedWeight',
        type: 'select',
        options: [
          { label: t('weight_xsmall'), value: t('weight_xsmall') },
          { label: t('weight_small'), value: t('weight_small') },
          { label: t('weight_medium'), value: t('weight_medium') },
          { label: t('weight_large'), value: t('weight_large') },
          { label: t('weight_xlarge'), value: t('weight_xlarge') }
        ],
        placeholder: t('estimatedWeightPlaceholder')
      },
      { label: t('dateFound'), name: 'dateFound', type: 'date', placeholder: t('dateFoundPlaceholder') },
      { label: t('foundNear'), name: 'foundNear', type: 'text', placeholder: t('foundNearPlaceholder') },
      { 
        label: t('sex'), 
        name: 'sex', 
        type: 'select', 
        options: [
          { label: t('male'), value: t('male') },
          { label: t('female'), value: t('female') },
          { label: t('unknown'), value: t('unknown') }
        ], 
        placeholder: t('sexPlaceholder') 
      },
      { label: t('your_name', 'Your Name'), name: 'contactName', type: 'text', placeholder: t('contactNamePlaceholder') },
      { label: t('uploadImage'), name: 'animalImage', type: 'file', placeholder: t('uploadImagePlaceholder') }
    ],
    'psa': [
      {
        label: t('psaTitle'),
        name: 'title',
        type: 'text',
        placeholder: t('psaTitlePlaceholder', 'e.g., Community Pet Meetup, Coyote Warning, Lost Pet Alert'),
        maxLength: 100
      },
      {
        label: t('psaDescription'),
        name: 'description',
        type: 'textarea',
        placeholder: t('psaDescriptionPlaceholder'),
        maxLength: 300
      },
      { 
        label: t('uploadImage', 'Upload Image (Optional)'), 
        name: 'psaImage', 
        type: 'file', 
        placeholder: t('uploadImagePlaceholder', 'Add a photo for your announcement') 
      }
    ],
    'pet-service': [
      {
        label: t('serviceTitle', 'Service Title'),
        name: 'title',
        type: 'text',
        placeholder: t('serviceTitlePlaceholder', 'e.g., Dog Walking, Pet Sitting, Grooming'),
        maxLength: 100
      },
      {
        label: t('serviceDescription', 'Service Description'),
        name: 'description',
        type: 'textarea',
        placeholder: t('serviceDescriptionPlaceholder', 'Describe your pet service, availability, pricing, etc.'),
        maxLength: 500
      },
      { 
        label: t('uploadImage', 'Upload Image (Optional)'), 
        name: 'serviceImage', 
        type: 'file', 
        placeholder: t('uploadImagePlaceholder', 'Add a photo for your service') 
      }
    ]
  }
});
